import { usePreventScroll } from '@react-aria/overlays';

function PreventScroll() {
  usePreventScroll();
  return null;
}

export { PreventScroll };
//# sourceMappingURL=PreventScroll.mjs.map
